import { Directive, ElementRef, HostListener, Input, NgModule } from '@angular/core';
import { AnalyticsService } from '../_services/analytics.service';

@Directive({
  selector: '[appAnalyticsClick]'
})
export class AnalyticsClickDirectiveDirective {

  @Input() buttonId!: string;
  @Input() pageName!: string;

  constructor(
    private analyticsService: AnalyticsService
  ) {}

  @HostListener('click') onClick() {
    if (this.buttonId && this.pageName) {
      this.analyticsService.logButtonClick(this.buttonId, this.pageName);
    }
  }

}

@NgModule({
  declarations: [AnalyticsClickDirectiveDirective],
  exports: [AnalyticsClickDirectiveDirective]
})
export class AnalyticsClickDirectiveModule {}